import { render, staticRenderFns } from "./ViewReportCard.vue?vue&type=template&id=6d8097a4"
import script from "./ViewReportCard.vue?vue&type=script&lang=js"
export * from "./ViewReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports